import React from 'react';
export function UrgencyBar() {
  return <div className="fixed top-0 left-0 w-full z-50 flex items-center justify-center px-4" style={{
    backgroundColor: '#0F2D4A',
    height: '44px'
  }} data-id="element-390">
      <p className="text-center w-full truncate" style={{
      color: '#FFFFFF',
      fontFamily: '"Plus Jakarta Sans", sans-serif',
      fontWeight: 600,
      fontSize: '13px'
    }} data-id="element-391">
        ⚡{' '}
        <span style={{
        color: '#FBB034'
      }} data-id="element-392">
          LIMITED
        </span>{' '}
        — Only 10 Homeowners Per Week · Phoenix Valley
      </p>
    </div>;
}